import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Avatar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as EMRIcon } from "../Icons/vuesax/direct-normal.svg";
import { ReactComponent as FileUploadIcon } from "../Icons/vuesax/document-upload.svg";
import { ReactComponent as GraphIcon } from "../Icons/vuesax/graph.svg";
import { ReactComponent as PeopleIcon } from "../Icons/vuesax/people.svg";
import { ReactComponent as InfoIcon } from "../Icons/vuesax/Info.svg";
import { ReactComponent as DocumentTextIcon } from "../Icons/vuesax/document-text.svg";
import { pca } from "../msalConfig";
import { PermissionsContext } from "../permission-context";

function NavBar() {
  const navigate = useNavigate();
  const activeAccount = pca.getActiveAccount();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const location = useLocation();
  const [selectedNavItem, setSelectedNavItem] = React.useState("");
  const { permissions, hasPermission, setPermissions } = React.useContext(PermissionsContext);

  React.useEffect(() => {
    if (location.pathname.endsWith("/emrentry")) {
      setSelectedNavItem("emr-entry");
    } else if (location.pathname.endsWith("/manage-users")) {
      setSelectedNavItem("manage-users");
    } else if (location.pathname.endsWith("/wci-ortho-surgery-visit")) {
      setSelectedNavItem("wci-ortho-surgery-visit");
    } else if (location.pathname.endsWith("/core-schedule-importer")) {
      setSelectedNavItem("core-schedule-importer");
    } else if (location.pathname.endsWith("/mrr-documents")) {
      setSelectedNavItem("mrr-documents");
    } else if (location.pathname.endsWith("/phone-dictation-status")) {
      setSelectedNavItem("phone-dictation-status");
    } else if (location.pathname.endsWith("/device-info")) {
      setSelectedNavItem("device-info");
    } else if (location.pathname.endsWith("/app-notification-logs")) {
      setSelectedNavItem("app-notification-logs");
    } else {
      setSelectedNavItem("");
    }
  }, [location.pathname]);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    navigate("/");
  };

  const handleSignOut = async () => {
    try {
      const logoutRequest = {
        account: activeAccount,
        postLogoutRedirectUri: process.env.REACT_APP_LogoutRedirectURI,
      };
      pca
        .handleRedirectPromise()
        .then((tokenResponse) => {
          setPermissions([]);
          pca.logoutRedirect(logoutRequest);
        })
        .catch((err) => {
          // Handle error
          console.error(err);
        });
    } catch (error) {
      console.error("Logout error:", error);
    }
    // handleClose();
  };

  // Function to get initials from account name
  const getInitials = () => {
    if (activeAccount && activeAccount.name) {
      const nameParts = activeAccount.name.split(" ");
      if (nameParts.length > 1) {
        return nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0);
      } else {
        return nameParts[0].charAt(0);
      }
    }
    return "";
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static'>
        <Toolbar>
          {permissions && permissions.length > 0 && (
            <IconButton
              edge='start'
              color='inherit'
              aria-label='menu'
              onClick={handleDrawerOpen}
              sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
            <div
              style={{
                display: "inline-block",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/home");
                navigate(0);
              }}>
              TransDyne
            </div>
          </Typography>
          {
            <div>
              <IconButton onClick={handleAvatarClick} sx={{ p: 0 }}>
                <Avatar sx={{ bgcolor: "#3f51b5", ml: 2 }}>{getInitials()}</Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}>
                <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
              </Menu>
            </div>
          }
        </Toolbar>
      </AppBar>
      <Drawer
        variant='persistent'
        anchor='left'
        open={openDrawer}
        onClose={handleDrawerClose}
        sx={{
          width: 350,
          flexShrink: 0,
          zIndex: (theme) => theme.zIndex.drawer,
          "& .MuiDrawer-paper": { width: 350, boxSizing: "border-box" },
        }}>
        <Box display='flex' justifyContent='flex-end' width='100%'>
          <IconButton onClick={handleDrawerClose}>
            <ArrowBackIosNewIcon />
          </IconButton>
        </Box>
        <List>
          {hasPermission("EMR") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/emrentry");
              }}
              selected={selectedNavItem === "emr-entry"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <EMRIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary='EMR Entry' />
            </ListItemButton>
          )}
          {hasPermission("PatientVisits") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/wci-ortho-surgery-visit");
              }}
              selected={selectedNavItem === "wci-ortho-surgery-visit"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <FileUploadIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary='WCI OrthoSurgery Visits Update' />
            </ListItemButton>
          )}
          {hasPermission("PatientVisits") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/core-schedule-importer");
              }}
              selected={selectedNavItem === "core-schedule-importer"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <FileUploadIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary='CoreSchedule Importer' />
            </ListItemButton>
          )}
          {hasPermission("MER") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/mrr-documents");
              }}
              selected={selectedNavItem === "mrr-documents"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <FileUploadIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary="MRR Documents" />
            </ListItemButton>
          )}
          {hasPermission("ViewVScribeAiPhoneDictStatus") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/phone-dictation-status");
              }}
              selected={selectedNavItem === "phone-dictation-status"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <GraphIcon width='1em' height='.85em' fontSize={"1.5em"} color='#3e3e3e' />
              </ListItemIcon>
              <ListItemText primary='Client Dictation Status' />
            </ListItemButton>
          )}
          {hasPermission("AppDeviceInfo") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/device-info");
              }}
              selected={selectedNavItem === "device-info"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <InfoIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary='App Device information' />
            </ListItemButton>
          )}
          {hasPermission("AppNotificationLogs") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/app-notification-logs");
              }}
              selected={selectedNavItem === "app-notification-logs"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <DocumentTextIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary='App Notification Logs' />
            </ListItemButton>
          )}
          {hasPermission("Admin") && (
            <ListItemButton
              onClick={() => {
                handleDrawerClose();
                navigate("/manage-users");
              }}
              selected={selectedNavItem === "manage-users"}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <PeopleIcon width='1em' height='.85em' fontSize={"1.5em"} />
              </ListItemIcon>
              <ListItemText primary='Manage Users' />
            </ListItemButton>
          )}
        </List>
      </Drawer>
    </Box>
  );
}
export default NavBar;
